import { StudyStoreState } from '@/enums/study-store-state';
import { IActionHelpers } from '@/interfaces/store/actions.interfaces';
import { BestFitResult, ScoreDeterminantType } from '@studyportals/bestfit-api-fe-client';
import { store } from './store';

const actionHelpers: IActionHelpers = {
	getPendingStudies(): number[] {
		const studyIds: number[] = [];
		const studyStores = store.getters.getAllStudyStores();

		for (const [studyId, studyStore] of studyStores) {
			if (studyStore.getters.storeState() === StudyStoreState.PENDING) {
				studyIds.push(studyId);
			}
		}

		return studyIds;
	},
	handleFailedStudies(
		fits: Map<number, Map<ScoreDeterminantType, BestFitResult>>,
		studyIdsToCalculate: number[],
	): void {
		const failedStudyIds: number[] = studyIdsToCalculate.filter(
			(id) => !fits.has(id),
		);

		for (const studyId of failedStudyIds) {
			store.getters.getStudyStore(studyId)?.mutations.setStoreState(StudyStoreState.FAILED);
		}
	},
};

export { actionHelpers };
